<h2 class="av-metric-card__title">
  {{ 'app.reports.monitoring.statusBreakdown.title' | translate }}
</h2>
<p class="av-metric-hint m-0">{{ 'app.reports.monitoring.statusBreakdown.hint' | translate }}</p>
@if (isEmpty()) {
  <av-empty-state icon="pie_chart" titleKey="app.reports.monitoring.statusBreakdown.empty" />
} @else {
  <div class="av-status-breakdown__kinds">
    @for (kind of kinds(); track kind.labelKey) {
      <section class="av-status-breakdown__kind">
        <h3 class="av-metric-card__subtitle">{{ kind.labelKey | translate }}</h3>
        @if (kind.total === 0) {
          <av-empty-state
            icon="pie_chart"
            titleKey="app.reports.monitoring.statusBreakdown.empty"
          />
        } @else if (kind.visibleTotal === 0) {
          <av-empty-state
            icon="visibility_off"
            titleKey="app.reports.monitoring.statusBreakdown.allHidden"
          />
        } @else {
          @defer (on immediate) {
            <av-donut-chart
              [segments]="kind.segments"
              [labelKey]="kind.labelKey"
              [showLegend]="false"
            />
          } @placeholder {
            <div class="av-status-breakdown__reserve"></div>
          } @loading (after 200ms; minimum 400ms) {
            <div class="av-status-breakdown__reserve av-chart-placeholder"></div>
          } @error {
            <av-empty-state icon="pie_chart" titleKey="shared.api.errors.default" />
          }
        }
      </section>
    }
  </div>
  <ul
    class="av-chart-legend av-status-breakdown__legend"
    [attr.aria-label]="'app.reports.monitoring.statusBreakdown.legend' | translate"
  >
    @for (item of legend(); track item.bucket) {
      <li class="av-chart-legend__item">
        <button
          type="button"
          class="av-status-breakdown__toggle"
          [attr.aria-pressed]="item.visible"
          (click)="toggleStatus(item)"
        >
          <span
            class="av-chart-legend__swatch av-chart-tone--{{ item.tone }}"
            aria-hidden="true"
          ></span>
          <span class="av-chart-legend__label">{{ item.labelKey | translate }}</span>
        </button>
      </li>
    }
  </ul>
  <span class="visually-hidden" aria-live="polite">{{ announcement() }}</span>
}
